let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6G6wt")).then(() => parcelRequire('14xmF'));